import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ roleRequired, children }) => {
  const { user, role, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-9 w-9 animate-spin rounded-full border-4 border-indigo-100 border-t-indigo-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (roleRequired && role !== roleRequired) return <Navigate to="/unauthorized" replace />;

  return children;
};

export default PrivateRoute;
